import * as yup from 'yup';
import { FormFields } from './types';
export const validationSchema = yup.object().shape({
    [FormFields.text]: yup.string().max(20).required(),
    [FormFields.emoji]: yup.mixed().required(),
    [FormFields.borderColor]: yup.string(),
    [FormFields.backgroundColor]: yup.string(),
    [FormFields.textColor]: yup.string(),
    [FormFields.canBeEarnedByMembers]: yup.boolean().when([FormFields.giveToSelectedMembers], {
        is: (giveToSelectedMembers) => giveToSelectedMembers === false,
        then: yup.boolean().required().oneOf([true], 'At least one rule or a member is required.'),
    }),
    [FormFields.removeWhenRulesNoLongerMet]: yup.boolean(),
    [FormFields.giveToSelectedMembers]: yup.boolean(),
    [FormFields.rules]: yup
        .array()
        .when(FormFields.canBeEarnedByMembers, {
        is: (canBeEarnedByMembers) => canBeEarnedByMembers,
        then: yup.array().min(1, 'At least one rule is required.'),
    })
        .test('hasOnlyEmpty', 'At least one rule is required.', (value) => {
        if (!value)
            return true;
        if (value.length === 1 && value[0].type === 'EmptyRule')
            return false;
        if (value.length === 1 && value[0].type === 'Tier' && !value[0].tierId)
            return false;
        return true;
    }),
    [FormFields.manuallyAssignedSupporters]: yup.array().when(FormFields.giveToSelectedMembers, {
        is: (giveToSelectedMembers) => giveToSelectedMembers,
        then: yup.array().min(1, 'At least one member is required.'),
    }),
    [FormFields.commentsWrittenMin]: yup.number().when(FormFields.rules, {
        is: (rules) => rules.some((rule) => rule.type === 'CommentsWritten'),
        then: yup.number().required().min(1),
    }),
    [FormFields.commentsWrittenMax]: yup.number(),
    [FormFields.likesGivenMin]: yup.number().when(FormFields.rules, {
        is: (rules) => rules.some((rule) => rule.type === 'LikesGiven'),
        then: yup.number().required().min(1),
    }),
    [FormFields.likesGivenMax]: yup.number(),
    [FormFields.likesReceivedMin]: yup.number().when(FormFields.rules, {
        is: (rules) => rules.some((rule) => rule.type === 'LikesReceived'),
        then: yup.number().required().min(1),
    }),
    [FormFields.likesReceivedMax]: yup.number(),
});
